import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { ITest } from "src/Interfaces/TestInterface";
import { IWell } from "src/Interfaces/WellInterface";
import PdfService from "src/Services/Pdf";
import TenantStore, { ITenant } from "src/Stores/Tenant/TenantStore";
import { TestsStore } from "src/Stores/Tests/TestsStore";
import { UserStore } from "src/Stores/User/UserStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";

@inject('stores')
@observer
export default class WellStoryReport extends React.Component {
    public props: any;
    private test: ITest;
    public TestsStore: TestsStore;
    private well: IWell;
    public WellsStore: WellsStore;
    public UserStore: UserStore;
    public TenantStore: TenantStore;
    private tenant: ITenant;

    public state = {
        reportLoading: true,
        tenant: this.tenant,
        test: this.test,
        well: this.well,
    };

    constructor(props: any) {
        super(props);
        this.TenantStore = this.props.stores.TenantStore;
        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.UserStore = this.props.stores.UserStore;
    }

    public componentDidMount() {
        this.getTestData();
        this.getWellData();
        this.getTenant();
        if (!this.UserStore.user) {
            this.UserStore.getProfile();
        }
    }


    public componentDidUpdate() {
        if (this.state.test !== undefined && this.state.well !== undefined && this.state.reportLoading) {
            this.renderIframe();
        }
    }

    private getTestData() {
        return this.TestsStore.getTestDetailsReport(this.props.match.params.taskId, this.props.match.params.wellId)
            .then(
                (data: any) => {
                    this.setState({
                        test: data
                    });
                }
            );
    }

    private getTenant() {
        return this.TenantStore.getTenant()
            .then(
                (data: any) => {
                    this.setState({
                        tenant: data
                    });
                }
            );
    }

    private getWellData() {
        return this.WellsStore.getWellReport(this.props.match.params.wellId)
            .then(
                (data: any) => {
                    this.setState({
                        well: data
                    });
                }
            );
    }

    private pdfReportBlob = () => {
        return PdfService.createWellStoryPdf(this.state.test, this.state.well, this.state.tenant);
    }

    private renderIframe() {
        return this.pdfReportBlob()
            .then(report => {
                this.setState({
                    reportLoading: false,
                });
                const myFrame: any = document.getElementById('my_frame');
                if (myFrame) {
                    myFrame.src = report;
                }
            });
    }

    public render() {
        if (this.state.test === undefined || this.state.well === undefined) {
            return (
                <div>
                    <FontAwesomeIcon
                        icon={faSpinner}
                        spin={true}
                        size={"8x"}
                        style={{ position: 'fixed', left: '50%', top: '35%' }}
                        />
                </div>
            );
        }
        return (
            <div>
                { this.state.reportLoading && 
                    <FontAwesomeIcon
                        data-html2canvas-ignore={true}
                        icon={faSpinner}
                        spin={true}
                        size={"8x"}
                        style={{ position: 'fixed', left: '50%', top: '35%' }}
                    />
                }
                <iframe id="my_frame" style={{ width: '100%', height: '2000px' }} />
                <div id="my-hidden-div" />
            </div>
        );
    }


}


// WEBPACK FOOTER //
// ./src/Components/Reporting/WellStoryReport.tsx